import * as filestack from 'filestack-js';

export default (ctx, inject) => {
  const client = filestack.init(process.env.filestack);

  ctx.$filestack = client;

  inject('filestack', client);
};
